import { Button, TabPanel, TabPanels, Text, useToast } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useFormik } from 'formik';
import { localise } from '../../../services/lang/lang';
import ModalWithSidebar from '../Modal/ModalWithSidebar';
import ContactsContent from '../Contacts/ContactsContent';
import ModalButtonContainer from '../Modal/ModalButtonContainer';
import { getGetAllContactsQueryKey, getGetRemoteSubmissionInvitesQueryKey, useInviteContactForRemoteSubmission, } from '../../../services/api/generated/client';
import useGenericMutationUseCase from '../../../hooks/usecases/generic/useGenericMutationUseCase';
import SentInvitationsContent from '../Contacts/SentInvitationsContent';
import { queryClient } from '../../../services/api/query/queryClient';
import RenderIfElse from '../RenderIf/RenderIfElse';
import ContactDetailContent from '../Contacts/Modal/ContactDetailsContent';
import { useUnsavedChanges } from '../UnsavedChanges/UnsavedChangesProvider';
import FormikModalErrorSync from '../Modal/FormikModalErrorSync';
import { ModalAddButton } from '../ModalAddButton/ModalAddButton';
import { makeMed4 } from '../../../styles/textStyles';
import { useTokens } from '../../../context/TokenProvider';
const RemoteSubmissionInvitesModal = (props) => {
    const [viewingContact, setViewingContact] = useState(undefined);
    const [addingContact, setAddingContact] = useState(false);
    const tokens = useTokens();
    const { attemptNavigate } = useUnsavedChanges();
    const toast = useToast();
    const sendInvite = useGenericMutationUseCase(useInviteContactForRemoteSubmission);
    const formik = useFormik({
        validateOnChange: false,
        initialValues: {
            selectedContact: undefined,
        },
        onSubmit: () => {
            sendInvite.execute({
                data: { contact_id: formik.values.selectedContact?.id },
            }, formik, {
                onSuccess: () => {
                    queryClient.invalidateQueries({
                        queryKey: getGetRemoteSubmissionInvitesQueryKey(props.inspection.id),
                    });
                    toast({
                        title: localise('INVITE_SENT'),
                        status: 'success',
                        isClosable: true,
                    });
                    formik.resetForm();
                },
            });
        },
    });
    const onContactSelected = (contact) => {
        if (formik.values.selectedContact?.id === contact.id) {
            formik.setFieldValue('selectedContact', undefined);
            return;
        }
        formik.setFieldValue('selectedContact', contact);
    };
    const handleClose = () => {
        formik.setErrors({});
        sendInvite.reset();
        props.onClose();
    };
    const onViewEditContactClicked = (contact) => {
        setViewingContact(contact);
        formik.setErrors({});
    };
    const onAddContactClick = () => {
        setAddingContact(true);
    };
    const onBackToContacts = () => {
        setViewingContact(undefined);
        setAddingContact(false);
    };
    const onAddEditContact = () => {
        queryClient.invalidateQueries({
            queryKey: getGetAllContactsQueryKey(props.inspection.id),
        });
        onBackToContacts();
    };
    const getTitle = () => {
        if (!viewingContact)
            return localise('TENANT_REPORTS');
        return props.canEditInspection
            ? localise('EDIT_CONTACT')
            : localise('VIEW_CONTACT');
    };
    return (React.createElement(ModalWithSidebar, { tabTitles: [localise('CONTACTS'), localise('SENT_INVITATIONS')], onClose: handleClose, title: getTitle(), isOpen: props.isOpen, isFullWidth: true, verifyOnBlur: attemptNavigate, selectedTab: props.selectedTab, onTabChange: () => {
            formik.setErrors({});
            sendInvite.reset();
            setViewingContact(undefined);
        } },
        React.createElement(TabPanels, null,
            React.createElement(TabPanel, null,
                React.createElement(RenderIfElse, { condition: !!viewingContact || addingContact, then: React.createElement(ContactDetailContent, { isAdd: addingContact, onAddEditContact: onAddEditContact, canEdit: props.canEditInspection, contact: viewingContact, onBack: onBackToContacts, inspectionId: props.inspection.id }), else: React.createElement(React.Fragment, null,
                        React.createElement(FormikModalErrorSync, { errors: formik.errors }),
                        React.createElement(ModalAddButton, { "data-testid": "add-contact_button" },
                            React.createElement(Text, { "data-testid": "add-contact_button__text", onClick: onAddContactClick, sx: makeMed4(tokens) }, localise('ADD_NEW_CONTACT'))),
                        React.createElement(ContactsContent, { onContactSelected: onContactSelected, inspection: props.inspection, variant: "modal", onContactDeleted: () => {
                                formik.resetForm();
                            }, selectedContact: formik.values.selectedContact, isTableInteractive: true, onEditContactClicked: onViewEditContactClicked }),
                        React.createElement(ModalButtonContainer, null,
                            React.createElement(Button, { isLoading: formik.isSubmitting, onClick: () => formik.handleSubmit(), variant: "primary" }, localise('SEND_INVITE')))) })),
            React.createElement(TabPanel, null,
                React.createElement(SentInvitationsContent, { inspection: props.inspection })))));
};
export default RemoteSubmissionInvitesModal;
